import React, { useContext, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { Add, MoreVert } from '@mui/icons-material';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import AddShowDialog from './AddShowDialog';
import DeleteShowDialog from './DeleteShowDialog';
import EditShowDialog from './EditShowDialog';

export default function Index() {
    const { selectedShow } = useContext(SeasonShowContext);

    const [addOpen, setAddOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpen = (dispatch: React.Dispatch<React.SetStateAction<boolean>>) => () => {
        handleClose();
        dispatch(true);
    }

    return (
        <>
            <IconButton sx={{ mh: 40 }} onClick={(e) => selectedShow ? handleClick(e) : setAddOpen(true)}>
                {selectedShow && <MoreVert />}
                {!selectedShow && <Add />}
            </IconButton>
            {selectedShow && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleOpen(setAddOpen)}>Add</MenuItem>
                    <MenuItem disabled={!selectedShow} onClick={handleOpen(setEditOpen)}>Edit</MenuItem>
                    <MenuItem disabled={!selectedShow} onClick={handleOpen(setDeleteOpen)}>Delete</MenuItem>
                </Menu>
            )}
            <AddShowDialog open={addOpen} onClose={() => setAddOpen(false)} />
            <EditShowDialog open={editOpen} onClose={() => setEditOpen(false)} />
            <DeleteShowDialog open={deleteOpen} onClose={() => setDeleteOpen(false)} />
        </>
    )
}